<template>
        <div style=" background: rgba(0,0,0,0)" :class="{'tile-clickable': tileClickable}" @click="onTileClick">
            <v-card-title class="justify-center pic-title mb-0 pa-1"><span style="z-index: 999;" class="tile-title-lg">{{data.action}}</span></v-card-title>
            <v-card-text class="justify pa-0 align-end align-content-end" style="height: 200px">
             <p v-if="data.text.length > 0" class="justify pic-text pa-3">
                 {{data.text}}
             </p>
            </v-card-text>
            <v-card-actions v-if="canMove(data.steps) && !isTrainer" class="justify-center  align-end">
                <div v-if="disableAllow && disabled">
                    <v-tooltip top open-delay="350">
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-btn
                                    class="move-cursor btn-shadow"
                                    Extra large Button
                                    min-width="50%"
                                    rounded

                                    :loading="isLoading"
                                    color="black--text"
                                    :class="buttonColor"
                                    :disabled="disableAllow && disabled"
                                    @click="action(getMoves())"
                                >

                                    {{data.button}} <span v-if="data.steps >0" class="ml-2">{{data.steps > 1 ? ' - '+data.steps : ''}}<v-icon class="ml-0 pl-0">mdi-shoe-print</v-icon> </span>
                                    <v-icon v-if="addDayIcon" class="ml-0 pl-0">mdi-white-balance-sunny</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <v-row style="width: 220px !important;">
                            <v-col cols="4">
                                <v-img
                                    src='@/assets/pic/web/Officer_Jenny.png'
                                    width="70"
                                    height="70"
                                    style="transform: scaleX(-1)"
                                />
                            </v-col>
                            <v-col>
                                {{ $t('journey.tile.notMissingAnyPokemonTooltip') }}
                            </v-col>
                        </v-row>
                    </v-tooltip>
                </div>
                <div v-if="(!disableAllow || !disabled) && !tileClickable">
                    <v-btn
                        class="move-cursor btn-shadow"
                        Extra large Button
                        min-width="50%"
                        rounded
                        :loading="isLoading"
                        color="black--text"
                        :class="buttonColor"
                        @click="action(getMoves())"
                    >
                        {{data.button}} <span v-if="data.steps >0" class="ml-2">{{data.steps > 1 ? ' - '+data.steps : ''}}<v-icon class="ml-0 pl-0">mdi-shoe-print</v-icon> </span>
                        <v-icon v-if="addDayIcon" class="ml-0 pl-0">mdi-white-balance-sunny</v-icon>
                    </v-btn>
                </div>
                <div v-if="tileClickable" class="tile-cost-pill black--text" :class="buttonColor">
                    {{data.button}} <span v-if="data.steps >0" class="ml-1">{{data.steps > 1 ? ' - '+data.steps : ''}}<v-icon small class="ml-0 pl-0">mdi-shoe-print</v-icon> </span>
                    <v-icon v-if="addDayIcon" small class="ml-0 pl-0">mdi-white-balance-sunny</v-icon>
                </div>
            </v-card-actions>
            <v-card-actions v-if="canMove(data.steps) && isTrainer" class="justify-center align-end mt-2">
                <v-btn
                    v-for="count in data.max"
                    :key="count"
                    class="move-cursor btn-shadow"
                    medium
                    rounded
                    :loading="isLoading"
                    color="black--text"
                    :class="buttonColor"
                    @click="action(count)"
                >
                    {{ count }}{{ $t('journey.tile.vsSeparator') }}{{ count }} <span v-if="data.steps > 0" class="ml-0">{{data.steps > 1 ? ' - '+data.steps : ''}}<v-icon class="ml-0 pl-0">mdi-shoe-print</v-icon></span>
                </v-btn>
            </v-card-actions>
            <v-card-actions v-if="!canMove(data.steps)" class="justify-center align-end">
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            class=" ml-2 mr-2"
                            v-if="!canMove(data.steps)"
                            v-bind="attrs" v-on="on"
                        >
                            <v-btn
                                large
                                rounded
                                disabled
                                :loading="isLoading"
                                color="black--text"
                                class="grey lighten-2 btn-shadow"
                                style="opacity: 1 !important; "
                            >
                                {{ $t('journey.tile.notEnoughStepsButtonLabel') }} <span v-if="data.steps >0" class="ml-2">{{data.steps > 1 ? ' - '+data.steps : ''}}<v-icon class="ml-0 pl-0">mdi-shoe-print</v-icon></span>
                            </v-btn>
                        </div>
                    </template>
                    <span>{{ $t('journey.tile.notEnoughStepsTooltip') }}</span>
                </v-tooltip>

            </v-card-actions>
        </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {isMobileMixin} from '@/utils/isMobileMixin';

    export default {
        name: 'Tile',
        components: {},
        mixins: [isMobileMixin],
        props: {
            data: {Object, default: () => {}},
            action: {Function, default: () => {}},
            buttonColor: {String, default: 'primary'},
            isTrainer: {Boolean, default: false},
            addDayIcon: {Boolean, default: false},
            disableAllow: {Boolean, default: false},
            disabled: {Boolean, default: false},
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
                steps: 'journey/steps',
                isLoading: 'journey/isLoading',
            }),
            // na mobilu je cela dlazdice klikadlo (misto tlacitka) - jen pro
            // jednoakcni, povolene dlazdice; trenerska (1V1/2V2/3V3) ma vyber
            tileClickable() {
                return this.isMobile
                    && !this.isTrainer
                    && this.canMove(this.data.steps)
                    && !(this.disableAllow && this.disabled);
            },
        },
        created() {
        },
        methods: {
            ...mapActions({
            }),
            canMove(steps) {
                if (!steps) return true;
                return steps <= this.steps;
            },
            getMoves(){
                return this.data && this.data.steps && this.data.steps > 0 ? this.data.steps : 0;
            },
            onTileClick() {
                if (this.tileClickable && !this.isLoading) {
                    this.action(this.getMoves());
                }
            },
        },
    }
</script>

<style scoped>
.tile-clickable {
    cursor: pointer;
}
.tile-cost-pill {
    border-radius: 16px;
    padding: 4px 14px;
    font-weight: 600;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.4);
    pointer-events: none;
}
@media (max-width: 959px) {
    .tile-title-lg {
        font-size: 22px !important;
    }
}
</style>

